import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
@Component({
  selector: 'app-add-party',
  templateUrl: './add-party.component.html',
  styleUrls: ['./add-party.component.scss']
})
export class AddPartyComponent implements OnInit {
  partyForm: FormGroup;
  busienessDetails:any=[];
  roles:any=[]
  parties:any=[]
  parentRoles:any=[]
  editStatus:boolean = false;
  editId:any
  options:any = []
  loggedUserInfo:any = []
  filteredOptions: Observable<string[]>;
  duplicateBusinessName:boolean = false
  duplicateGstin:boolean = false
  editBusienessName:any=''
  editGstin:any=''
  constructor(private observables:ObservablesService, private formBuilder: FormBuilder,private api:ApiService) { }

  ngOnInit() {
    // this.createForm()
    // this.getBusinesses()
    this.createForm()
    // this.getBusinesses()
    this.api.getLoggedUserInfo().then((res:any)=>{
      // console.log("logged users data=",res)
      if(res.data.length > 0){
        this.loggedUserInfo = res.data[0];
        this.getRoles();
        this.getParties();
        this.getUsers()
      }else{
        this.api.logOut()
      }
    })
  }

  createForm(){
    this.partyForm = this.formBuilder.group({
      business_id:[null],
      user_id:[null, Validators.required],
      user_name:[null, Validators.required],
      business_name:[null, Validators.required],
      party_name:[null, Validators.required],
      gstin:[''],
      mobile:[null, Validators.required],
      email:[null],
      address:[null],
      city:[null],
      state:[null],
      pincode:[null]
    });
  }



  // getBusinesses(){
  //
  //    this.api.send("findDb",{
  //      table:"businesses",
  //      conditions:[{id:2}]
  //    }).then((result:any)=>{
  //      this.busienessDetails=result.data[0]
  //      this.getRoles();
  //      this.getParties();
  //      this.getUsers()
  //    })
  // }
  getRoles(){
    this.api.send("findDb",{
      table:"roles",
      conditions:[{business_id:this.loggedUserInfo.business_id}]
    }).then((result:any)=>{
      this.roles=result.data
    })
  }

  getParties(){
    this.api.send('findDb',{
      table:'parties as P',
      fields:['P.*','U.*','R.*','P.id','P.mobile'],
      joins:[{
        type:"left",
        table:'users as U',
        conditions:["U.id = P.user_id"]
      },{
        type:"left",
        table:'roles as R',
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{'U.business_id':this.loggedUserInfo.business_id}]
    }).then((result:any)=>{
      this.parties=result.data
      // console.log("parties=",this.parties)
    })
  }

  getUsers(){
    this.api.send('findDb',{
      table:'users as U',
      fields:['U.id as user_id','U.full_name','R.role'],
      joins:[{
        type:"left",
        table:'roles as R',
        conditions:["R.id = U.role_id"]
      }],
      conditions:[{'U.business_id':this.loggedUserInfo.business_id}]
    }).then((res:any)=>{
      if(res.data.length > 0){

        this.parentRoles = res.data;
        // console.log('parent users=',this.parentRoles)
        this.options = res.data;
        this.options.filter((item)=>{
          if(item.user_id == this.loggedUserInfo.id){
            this.partyForm.patchValue({user_id:item.user_id,user_name: item.role+"-"+ item.full_name})
          }
        })

        this.filteredOptions = this.partyForm.get('user_name').valueChanges
        .pipe(
          startWith(''),
          map(value => value ? this._filter(value) :this.parentRoles.slice())
        );
      }
    })
  }

  onSelectionChanged(_event: any,userData) {

    if (_event.isUserInput) {

      this.partyForm.patchValue({user_id:userData.user_id})

    }

  }

  private _filter(value: any): string[] {
    if(value){
      const filterValue = value.toLowerCase();
      return this.options.filter(option => option.full_name.toLowerCase().includes(filterValue) || option.role.toLowerCase().includes(filterValue));
    }
  }

  submitData(value,formDirective:FormGroupDirective){
    // console.log(value)
    this.checkBusinessExist(value.business_name,null).then((res:any)=>{
      if(res){
        this.duplicateBusinessName = true;
        return;
      }else{
        this.duplicateBusinessName = false;
        if(value.gstin.length > 0){

          this.checkBusinessExist(null,value.gstin.toUpperCase()).then((resp:any)=>{
            if(resp){
              this.duplicateGstin = true;
              return;
            }else{
              this.duplicateGstin = false;
              this.save(value,formDirective)
            }
          })
        }else{
          this.save(value,formDirective)
        }

      }
    })
  }

  save(value,formDirective){
    this.api.send("insertDb",{
      table:"parties",
      data:{
          business_id:this.loggedUserInfo.business_id,
          user_id:value.user_id,
          business_name:value.business_name,
          party_name:value.party_name,
          gstin:value.gstin.toUpperCase(),
          mobile:value.mobile,
          email:value.email,
          address:value.address,
          city:value.city,
          state:value.state,
          pincode:value.pincode
        }
      }).then((result:any)=>{
        if(result.data.affectedRows){
          formDirective.resetForm();
          this.partyForm.reset()
          this.getParties();
          this.options.filter((item)=>{
            if(item.user_id == this.loggedUserInfo.id){
              this.partyForm.patchValue({user_id:item.user_id,user_name: item.role+"-"+ item.full_name})
            }
          })
          this.duplicateBusinessName = false;
          this.duplicateGstin = false;
          this.observables.refreshHeaderPartyStatus.next()
          this.observables.showToastMessage({type:0, message:"Party Added Successfully"})
        }else{

          this.observables.showToastMessage({type:1, message:"Some problem while adding Party details, try again."})
        }
      })
  }

  checkBusinessExist(business_name,gstin){
    return new Promise((resolve)=>{
      let condition:any = ''
      if(business_name){
        condition = {
          business_id:this.loggedUserInfo.business_id,
          business_name:business_name
        }
      }else{
        condition = {
          business_id:this.loggedUserInfo.business_id,
          gstin:gstin
        }
      }

      this.api.send('findDb',{
        table:'parties',
        conditions:[condition]
      }).then((res:any)=>{
        // console.log("abcd==",res)
        if(res.data.length > 0){
          resolve(true)
        }else{
          resolve(false)
        }
      })
    })
  }

  cancel(formDirective:FormGroupDirective){
    formDirective.resetForm();
    this.partyForm.reset()
    this.editStatus = false;
    this.editId = '';
    this.editBusienessName = '';
    this.editGstin = '';
    this.options.filter((item)=>{
      if(item.user_id == this.loggedUserInfo.id){
        this.partyForm.patchValue({user_id:item.user_id,user_name: item.role+"-"+ item.full_name})
      }
    })
  }
  updateData(value,formDirective:FormGroupDirective){
    // console.log("values==",value)
    this.checkBusinessExist(value.business_name,null).then((res:any)=>{
      if(res && this.editBusienessName != value.business_name){
        this.duplicateBusinessName = true;
        return;
      }else{
        this.duplicateBusinessName = false;
        if(value.gstin.length > 0){

          this.checkBusinessExist(null,value.gstin.toUpperCase()).then((resp:any)=>{
            if(resp && this.editGstin != value.gstin.toUpperCase()){
              this.duplicateGstin = true;
              return;
            }else{
              this.duplicateGstin = false;
              this.update(value,formDirective)
            }
          })
        }else{
          this.update(value,formDirective)
        }

      }
    })

  }

  update(value,formDirective){
    this.api.send("updateDb",{
      table:"parties",
      data:{
        business_id:this.loggedUserInfo.business_id,
        user_id:value.user_id,
        business_name:value.business_name,
        party_name:value.party_name,
        gstin:value.gstin.toUpperCase(),
        mobile:value.mobile,
        email:value.email,
        address:value.address,
        city:value.city,
        state:value.state,
        pincode:value.pincode
      },
      conditions:[{id:this.editId}]
    }).then((result:any)=>{
      if(result.data.affectedRows){
        formDirective.resetForm();
        this.partyForm.reset()
        this.getParties();
        this.options.filter((item)=>{
          if(item.user_id == this.loggedUserInfo.id){
            this.partyForm.patchValue({user_id:item.user_id,user_name: item.role+"-"+ item.full_name})
          }
        })
        this.editStatus = false;
        this.editId = '';
        this.editBusienessName = '';
        this.editGstin = '';
        this.observables.refreshHeaderPartyStatus.next()
        this.observables.showToastMessage({type:0, message:"Party Updated Successfully"})
      }else{
        this.observables.showToastMessage({type:1, message:"Some problem while updating party details, try again."})
      }
    })
  }


  deleteParty(id){
    if(confirm("Are you sure want to delete Party?")){

      this.api.send("deleteDb",{
        table:"parties",
        conditions:[{id:id}]
      }).then((result:any)=>{
        if(result.data.affectedRows){
          this.observables.showToastMessage({type:0, message:"Party Deleted Successfully"})
          this.getParties();
          this.observables.refreshHeaderPartyStatus.next()
        }

      })
    }
  }

  editParty(value){
    this.partyForm.patchValue({
      business_id:value.business_id,
      user_id:value.user_id,
      business_name:value.business_name,
      party_name:value.party_name,
      gstin:value.gstin,
      mobile:value.mobile,
      email:value.email,
      address:value.address,
      city:value.city,
      state:value.state,
      pincode:value.pincode
    });

    this.parentRoles.filter(item=>{
      // console.log(item)
      if(item.user_id == value.user_id){
        this.partyForm.patchValue({user_name:item.role+"-"+item.full_name})
      }
    })

    this.editStatus = true;
    this.editId = value.id;
    this.editBusienessName = value.business_name
    this.editGstin = value.gstin
  }

}
